export const MODAL_SHOW__REPREPARATION_REASON = 'MODAL_SHOW__REPREPARATION_REASON';
export const MODAL_HIDE__REPREPARATION_REASON = 'MODAL_HIDE__REPREPARATION_REASON';
export const MODAL_SHOW__BLOCKING_EXIT_REASON = 'MODAL_SHOW__BLOCKING_EXIT_REASON';
export const MODAL_SHOW__BLOCKING_EXIT_REASON__AFTER_LOAD = 'MODAL_SHOW__BLOCKING_EXIT_REASON__AFTER_LOAD';
export const MODAL_HIDE__BLOCKING_EXIT_REASON = 'MODAL_HIDE__BLOCKING_EXIT_REASON';
export const MODAL_SHOW__CANTEEN_ORDERS = 'MODAL_SHOW__CANTEEN_ORDERS';
export const MODAL_HIDE__CANTEEN_ORDERS = 'MODAL_HIDE__CANTEEN_ORDERS';
